// @flow
import { Record } from 'immutable';
import PwrCloudinary, { type UrlSet } from 'lib/pwr-cloudinary';
import startCase from 'lodash/startCase';
import Catalog from './Catalog';

type AssociatedProduct = {
  page_id: ?string,
  product_name: ?string,
  product_image_url: ?string,
  variant_id: ?string,
};

type ProductRecordShape = {
  subject_id: ?string,
  subject_type: ?string,
  name: ?string,
  description: ?string,
  category_name: ?string,
  page_id: ?string,
  page_id_variant: ?string,
  product_id: ?string,
  product_url: ?string,
  product_image_url: UrlSet,
  locale: ?string,
  brand_name: ?string,
  merchant: ?Catalog,
  associated_products: Array<AssociatedProduct>,
};
const defaultProductRecordShape: ProductRecordShape = {
  subject_id: null,
  subject_type: null,
  name: 'Unknown Product',
  description: '',
  category_name: '',
  page_id: null,
  page_id_variant: null,
  product_id: null,
  product_url: null,
  product_image_url: {
    raw: '',
    thumbnail: '',
    small: '',
    medium: '',
    large: '',
    full: '',
  },
  locale: 'en_US',
  brand_name: '',
  merchant: Catalog.Empty,
  associated_products: [],
};

const ProductRecord = Record(defaultProductRecordShape);
const defaultUrlSet = PwrCloudinary.fetchUrlSet('');

const stripTrailingColon = category_name => category_name.replace(/:$/g, '');

export default class Product extends ProductRecord {
  constructor(props: ?ProductRecordShape) {
    super({
      product_image_url: defaultUrlSet,
      ...props,
      category_name:
        props && typeof props.category_name === 'string'
          ? stripTrailingColon(props.category_name)
          : '',
    });
  }

  static createWithData(data: ContentBlob) {
    if (!data.subject) {
      throw new TypeError('Invalid argument');
    }
    if (startCase(data.subject.subject_type) !== 'Product') {
      throw new TypeError(
        `Invalid subject_type:${data.subject.subject_type}, expects "Product"`
      );
    }

    const { product_url = '', product_image_url = '', merchant } = data.subject;

    const { associated_products = [] } = data.subject;

    // $FlowFixMe
    return new Product({
      ...data.subject,
      product_url: product_url === 'nullnull' ? '' : product_url,
      product_image_url: PwrCloudinary.fetchUrlSet(
        product_image_url.replace('nullnull', '')
      ),
      catalog: new Catalog(merchant),
      associated_products,
    });
  }
}



// WEBPACK FOOTER //
// ./src/models/Product.js